var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order
    ? _c(
        "q-card",
        [
          _c(
            "q-card-section",
            [
              _c("div", { staticClass: "text-h6" }, [
                _vm._v("\n      Состав заказа\n    ")
              ]),
              _vm._v(" "),
              _c("Table", {
                attrs: {
                  "table-id": "PageOrdersDetailsTable",
                  "table-config": _vm.tableConfig,
                  "table-data": _vm.order.orderList,
                  "current-page": _vm.page,
                  pages: _vm.totalPages
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("q-card-section", [
            _c("div", { staticClass: "text-h6" }, [
              _vm._v("\n      Детали заказа\n    ")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Номер заказа:")]),
              _vm._v(" " + _vm._s(_vm.order.orderNumber))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Дата создания заказа:")]),
              _vm._v(" " + _vm._s(_vm.order.orderCreatedAtDate))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Время создания заказа:")]),
              _vm._v(" " + _vm._s(_vm.order.orderCreatedAtTime))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Стоимость заказа:")]),
              _vm._v(" " + _vm._s(_vm.order.orderCost))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Статус заказа:")]),
              _vm._v(" " + _vm._s(_vm.order.orderStatus))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Статус оплаты заказа:")]),
              _vm._v(" " + _vm._s(_vm.order.orderPaymentStatus))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Статус доставки заказа:")]),
              _vm._v(" " + _vm._s(_vm.order.orderDeliveryStatus))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("ФИО сборщика заказа:")]),
              _vm._v(" " + _vm._s(_vm.order.orderCollectorFullName))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Адрес точки А:")]),
              _vm._v(" " + _vm._s(_vm.order.addressFrom))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Номер магазина:")]),
              _vm._v(" " + _vm._s(_vm.order.shopNumber))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Адрес точки B:")]),
              _vm._v(" " + _vm._s(_vm.order.addressTo))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Комментарий к заказу от клиента:")]),
              _vm._v(" " + _vm._s(_vm.order.commentFromClient))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("“Бесконтактная доставка”:")]),
              _vm._v(" " + _vm._s(_vm.order.contactlessDelivery))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("ФИО клиента, оформившего заказ:")]),
              _vm._v(" " + _vm._s(_vm.order.customerFullName))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Название курьерской службы:")]),
              _vm._v(" " + _vm._s(_vm.order.courierServiceName))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("ФИО курьера:")]),
              _vm._v(" " + _vm._s(_vm.order.courierFullName))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("strong", [_vm._v("Телефон курьера:")]),
              _vm._v(" " + _vm._s(_vm.order.courierPhone))
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }